import { StorageKey, useLocalStorage } from './useLocalStorage';
import { LangKey } from '@/utils/language';

export const useLanguage = (): LangKey => {
  return useLocalStorage(StorageKey.LANG_KEY) as LangKey;
};
